<template>
  <TransitionRoot as="template" :show="property_typeopen">
    <Dialog as="div" class="relative z-[9999]" @click="property_typeopen = false">
      <div class="fixed inset-0" />
      <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
          <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
            <TransitionChild as="template" enter="transform transition ease-in-out duration-500 sm:duration-700"
              enter-from="translate-x-full" enter-to="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700" leave-from="translate-x-0"
              leave-to="translate-x-full">
              <DialogPanel class="pointer-events-auto w-screen max-w-md">
                <form class="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
                  <div class="h-0 flex-1 overflow-y-auto">
                    <div class="bg-indigo-700 px-4 py-6 sm:px-6">
                      <div class="flex items-center justify-between">
                        <DialogTitle class="text-base font-semibold leading-6 text-white">Property Type</DialogTitle>
                        <div class="ml-3 flex h-7 items-center">
                          <button type="button"
                            class="relative rounded-md bg-indigo-700 text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                            @click="property_typeopen = false">
                            <span class="absolute -inset-2.5" />
                            <span class="sr-only">Close panel</span>
                            <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                          </button>
                        </div>
                      </div>
                      <div class="mt-1">
                        <p class="text-sm text-indigo-300">Select Property Types for this post.</p>
                      </div>
                    </div>
                    <div class="flex flex-1 flex-col justify-between">
                      <div class="divide-y divide-gray-200 px-4 sm:px-6">
                        <div class="space-y-6 pb-5 pt-6">
                          <div class="mt-1 rounded-md border border-gray-300 p-3" v-if="edit == false">
                            <div class="grid grid-cols-2 gap-y-2 gap-x-1 mb-1">
                              <div class="font-14 pt-3 pb-3 font-bold">List Of Property Types</div>
                              <div class="text-right mt-3">
                                <Button :name="'Add'" :icon="'fa-solid fa-plus'" :method="open_edit"></Button>
                              </div>
                            </div>
                            <hr>
                            <div class="grid grid-cols-1 gap-y-2 gap-x-1 mt-1  max-h-[322px] overflow-y-auto">

                              <div class="form-check form-check-inline flex" v-for="property_type in property_type_list"
                                :key="property_type.id">
                                <div class=" ">
                                  
                                  <input
                                    class="form-check-input appearance-none h-4 w-4 border border-gray-300 rounded-sm bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                                    type="checkbox" :id="'decisioninfo-' + property_type.id" v-model="property_type_data"
                                    :value='property_type.id'>
                                </div>
                                <div>
                                  <label class="form-check-label inline-block text-gray-800"
                                    :for="'decisioninfo-' + property_type.id">
                                    {{ property_type.type_title }}
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-if="edit == true"
                            class="mt-1 rounded-md border border-gray-300 p-3 max-h-[485px] overflow-y-auto">
                            <div class="clearfix">
                              <a class=" float-right font-semibold  rounded-[50%] shadow-sm text-sm text-red-800 cursor-pointer" @click="edit = false">
                                  <i class="fa-solid fa-xmark p-1"></i>
                              </a>
                            </div>
                            
                            <form @submit.prevent="data_submit">
                              <text-input v-model="form.type_title" :error="form.errors.type_title" class="pb-8 pr-6 w-full " label="Name of Property type" required="true" placeholder="i.e Apartment"/>
                              <select-input v-model="form.pid" :error="form.errors.pid" class="pb-8 pr-6 w-full " label="Name of Parents" >
                                <option value=null >Select Parents</option>
                                <option v-for="propertyType in property_type_list" :key="propertyType.id" :value='propertyType.id'>{{ propertyType.type_title }}</option>
                              </select-input>
                              <textarea-input v-model="form.short_desc" :error="form.errors.short_desc" class="pb-8 pr-6 w-full " label="Short Desc. of Property type" required="true" placeholder="i.e "/>
                              <text-input v-model="form.hierarchy" :error="form.errors.hierarchy" class="pb-8 pr-6 w-full " label="Hierarchy" placeholder="i.e 1" type="number" oninput="this.value = Math.abs(this.value)" min="0"/>
                              <div class="pb-8 pr-6 w-full  grid grid-cols-12">
                                <text-input v-model="form.icon" :error="form.errors.icon" class="col-span-11" label="Icon" placeholder="i.e 1" disabled/>
                                <vue3-icon-picker v-model="form.icon" class="mt-5"/>
                              </div> 
                              <status-toogle-button v-model="form.status" :error="form.errors.status" label="Status of Category" class="pb-8 pr-6 w-full  mt-5"></status-toogle-button>  
                              <div class="px-4 py-4">
                                <FloatingActionBtnFix :loader="preloader" :icon="'fa fa-check'" :message="message"
                                  @dataSubmit="data_submit" @removeMessage="remove_msg" />
                              </div>
                            </form>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="flex flex-shrink-0 justify-end px-4 py-4" v-if="edit == false">
                   

                    <button type="button" @click="property_typeopen = false"
                      class="ml-4 inline-flex justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Save</button>
                  </div>
                </form>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup>


import axios from 'axios';
import { ref, toRefs, inject, onMounted, watch } from 'vue'
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'

import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import StatusToogleButton from '@/Shared/StatusToogleButton'
import FileInput from '@/Shared/FileInput'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import Button from '@/Shared/Button'
import FloatingActionBtnFix from "@/Shared/Buttons/FloatingActionBtnFix"
import Vue3IconPicker from '@/Shared/components/Vue3IconPicker'
import { LinkIcon, PlusIcon, QuestionMarkCircleIcon } from '@heroicons/vue/20/solid'
const props = defineProps(['property_types', 'property_type_list', 'property_typeopen'])
const property_type_data = ref(props.property_types)
const backendPrefix = ref(process.env.MIX_ADMIN_PREFIX)
const edit = ref(false)
const swal = inject('$swal')  
const preloader = ref(false)
const message = ref('');
const form = useForm({
  type_title: null,
  pid: null,
  icon: 'fas fa-upload',
  short_desc: null,
  hierarchy: null,
  status: true,
})
const emit = defineEmits(['UpdatePropertyTypePopup', 'UpdatePropertyType'])

const property_type_list = ref([])
const load_property_types = async () => {
  await axios.post(`/${backendPrefix.value}/property-types/activepropertytypes`)
    .then(function (response) {
      ////console.log(response);
      property_type_list.value = response.data
    }.bind(this));
}


const open_edit = () => {
  edit.value = true
}

const save = () => {
  emit('UpdatePropertyTypePopup', props.property_typeopen)
  emit('UpdatePropertyType', property_type_data)
}

const set_photo = (val) => {
            form.image_path = val
        }
watch(() => props.property_typeopen, () => {
  emit('UpdatePropertyTypePopup', props.property_typeopen)
}, { deep: true })
watch(() => property_type_data, () => {
  emit('UpdatePropertyType', property_type_data)
}, { deep: true })

onMounted(() => {
  load_property_types()
})
const remove_msg = () => {
            message.value = ''
        }
const data_submit = () => {
    preloader.value = true
    axios.post(`/${backendPrefix.value}/property-types/store-api`, form).then(async (response) => {        
        load_property_types()        
        message.value = response.data.message
        preloader.value = false
        edit.value=false
    }).catch(error => { 
        preloader.value = false
    })
}
</script>